<template>
  <div v-if="!nodos.length">
    <blockquote class="quote quote-maps-primary quote-first">
      <p>
        <span>
          {{ $t('mEditionMapChart.quote.firstText') }}
          {{ $t('mEditionMapChart.quote.secondText') }}
          <router-link
            :to="`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`"
            class="text-color-maps-primary"
          >
            {{ $t('mEditionMenu.map.path.text') }}.
          </router-link>
        </span>
      </p>
    </blockquote>
  </div>
  <div
    v-else
    class="m-edition-map-chart"
  >
    <div class="m-edition-map-chart-item-left">
      <MoleculeEditionMapChartBoard :progress="progress" />
    </div>
    <div class="m-edition-map-chart-item-right">
      <MoleculeEditionMapChartPoints @setProgress="setProgress" />
    </div>
  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionMapChart',

  components: {
    MoleculeEditionMapChartBoard: () => import('@/components/molecules/MoleculeEditionMapChartBoard'),
    MoleculeEditionMapChartPoints: () => import('@/components/molecules/MoleculeEditionMapChartPoints')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      progress: []
    }
  },

  computed: {
    nodos () {
      return [...this.$store.getters.getAssetNodes]
    }
  },

  methods: {
    setProgress (progress) {
      this.progress = [...progress]
    }
  }
}
</script>
